
import FormInput from "@/components/main/forms/FormInput";
import {email, required, minLength} from "vuelidate/lib/validators";
import DashModal from "@/components/dashboard/DashModal";
import "@/plugins/vuelidate"
import validationErrors from "@/mixins/validationErrors";

export default {
  name: "FeedBackContacts",
  mixins: [validationErrors],
  components: { FormInput, DashModal},
  props: {
    options: Array,
    required: true,
    choiceId: '',
  },

  validations: {
    first_name: {required, minLength: minLength(3)},
    last_name: {required, minLength: minLength(3)},
    email: {
      required,
      email: value => {
        if (/\s/.test(value)) {
          return false;
        }
        const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
        return emailRegex.test(value);
      }
    },
  },

  data() {
    return {
      first_name: '',
      last_name: '',
      email: '',
      message: '',
      optionsTitle: 'Please Choose Your Issue Below',
      optionsOpen: false,
      captchaChecked: false,
      captchaResponse: null,
    }
  },

  mounted() {
    this.isRemove()
  },
  computed: {
    someFormErrors() {
      return this.$v.first_name.$error
        || this.$v.last_name.$error
        || this.$v.email.$error
        || this.optionsTitle === 'Please Choose Your Issue Below'
        || !this.captchaChecked
    }
  },
  methods: {
    async submit() {
      this.captchaResponse = await this.$recaptcha.getResponse();
      let self = this;
      this.$axios.post(`${process.env.API_BASE_URL}/api/contact`, {
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        subject: this.optionsTitle,
        message: this.message,
        'g-recaptcha-response': this.captchaResponse,
      })
        .then(function (response) {
          self.first_name = ''
          self.$v.first_name.$reset()
          self.last_name = ''
          self.$v.last_name.$reset()
          self.email = ''
          self.$v.email.$reset()
          self.message = ''
          self.optionsTitle = 'Please Choose Your Issue Below'
          self.captchaResponse = null;

          self.$notify({
            group: 'main',
            title: 'Success',
            text: response.data.message,
            type: 'success',
            speed: 1000,
            duration: 10000,
          });
        })
        .catch(function (error) {
          if (error.response && (error.response.status === 422 || error.response.status === 429)) {
            self.displayValidationErrors(error.response);
          } else {
            console.error(error);
          }
        })
        .finally(function () {
          self.refreshCaptcha();
        })
    },

    openOptions() {
      this.optionsOpen = true
    },
    choiceIssue(option) {
      this.optionsOpen = false

      this.optionsTitle = option
    },
    isRemove() {
      if (this.$router.app.context.from) {
        this.$router.app.context.from.name === 'remove-info' ? this.optionsTitle = 'Remove My Info' : null
      }
    },
    changeCaptchaChecked() {
      this.captchaChecked = true;
    },
    onExpired() {
      this.captchaChecked = false;
    },
    refreshCaptcha() {
      this.$recaptcha.reset();
      this.captchaChecked = false;
      this.captchaResponse = null;
    },
  }
}
